import {PANNEAU_ROUTES as panneauRoutes} from "~/api/routes";

export const state = () => ({
  panneau: [],
  panneau_draft: [],
  close: false
});
export const getters = {
  panneau: state => state.panneau,
  panneau_draft: state => state.panneau_draft
};
export const mutations = {
  SAVE_PANNEAU(state, params){
    state.panneau = params;
  },
  SAVE_PANNEAU_DRAFT(state, params){
    state.panneau_draft = params;
  },
  UPDATE_ZONE(state, params){
    state.panneau = state.panneau.map(p =>{
      if (p.zone === params.zone)
        return params;
      return p;
    })
  },
  CLOSE_MODAL(state, params){
    state.close = params;
  },
};
export const actions = {
  list({commit}){
    return new Promise((resolve, reject) => {
      this.$api.request(panneauRoutes.list).then(res=>{
        commit('SAVE_PANNEAU',res.payload)
      }).catch(err=>{
        console.log(err);
      });
    });
  },
  update({commit}, params){
    commit('CLOSE_MODAL', false);
    // params.append('is_draft', 0)  ; // JUST TO FIX TEPM BUG REMOVE LATER
    return new Promise((resolve, reject) => {
      this.$api.request(panneauRoutes.update, {}, params).then(res=>{
        commit('UPDATE_ZONE', res.payload);
        resolve(res);
      }).catch(err=>{
        console.log(err);
        commit('CLOSE_MODAL', false);
      });
    });
  },
  publishDraft({commit}){
    commit('CLOSE_MODAL', false);
    // params.append('is_draft', 0)  ; // JUST TO FIX TEPM BUG REMOVE LATER
    return new Promise((resolve, reject) => {
      this.$api.request(panneauRoutes.apply_drafts).then(res=>{
        commit('UPDATE_ZONE', res.payload);
        commit('CLOSE_MODAL', true);
        resolve();
      }).catch(err=>{
        commit('CLOSE_MODAL', false);
        reject();
      });
    });
  },
  getDrafts({commit}){
    return new Promise((resolve, reject) => {
      this.$api.request(panneauRoutes.get_drafts).then(res => {
        commit('SAVE_PANNEAU_DRAFT', res.payload);
        resolve();
      }).catch(err=>{
        console.log(err);
        reject(err);
      });
    });
  },
  closeModal({commit}, params){
    commit('CLOSE_MODAL', params);
  },
};
